// Initialize Firebase
import firebase from "firebase/app"
import 'firebase/firestore'
var firebaseConfig = {
    apiKey: "AIzaSyAFO9hD4l1IkFO9m1mT225x8BXPxBSIFWY",
    authDomain: "yelpoll.firebaseapp.com",
    databaseURL: "https://yelpoll.firebaseio.com",
    projectId: "yelpoll",
    storageBucket: "yelpoll.appspot.com",
    messagingSenderId: "813488720786"
};
const firebaseApp = firebase.initializeApp(firebaseConfig)
export default firebaseApp.firestore()